import React, { useEffect, useState } from "react";
import { InputGroup, Button, Intent, MenuItem } from "@blueprintjs/core";
import { Select } from "@blueprintjs/select";
import { Translate } from "react-redux-i18n";
import { PhonePrefixes } from "../../utils/utils";
import { PhoneRounded } from "@material-ui/icons/";
const PhonePrefixSelect = Select.ofType();

export default function PhoneNumberInput({ errors, updateFields }) {
  const [phonePrefix, setPhonePrefix] = useState(PhonePrefixes[2]);
  const [phoneNumber, setPhoneNumber] = useState("");

  useEffect(() => {
    const number = `${phonePrefix.value}${phoneNumber}`;
    updateFields({ target: { id: "mobile_phone", value: number } });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [phonePrefix, phoneNumber]);

  const updatePhoneNumber = (event) => {
    const value = event.currentTarget.value;
    setPhoneNumber(value);
  };

  const renderFilm = (prefix, itemProps) => {
    return (
      <MenuItem
        active={itemProps.modifiers.active}
        key={prefix.country}
        label={prefix.country}
        onClick={itemProps.handleClick}
        className="country-code-menu-item"
      />
    );
  };
  return (
    <div className={errors ? "form-group error" : "form-group"}>
      <label htmlFor="mobile_phone">
        {errors && (
          <label htmlFor="last_name">
            <Translate value={errors} />
          </label>
        )}
      </label>
      <InputGroup
        type="number"
        placeholder="740123456"
        fill={true}
        id="mobile_phone"
        intent={errors ? Intent.DANGER : Intent.NONE}
        className="phone-number-country-code"
        onChange={updatePhoneNumber}
        required
        rightElement={
          <div className="purchase-form-input-icon">
            <PhoneRounded className="icon" size="16" />
          </div>
        }
        leftIcon={
          <PhonePrefixSelect
            filterable={false}
            items={PhonePrefixes}
            itemRenderer={renderFilm}
            onItemSelect={setPhonePrefix}
            activeItem={phonePrefix}
            className="phone-prefix-list">
            <Button text={phonePrefix.country} rightIcon="double-caret-vertical" className="country-button" />
          </PhonePrefixSelect>
        }
      />
      <div className="small-input-explainer">
        <Translate value="grannbox_onboarding.why_phone" />
      </div>
    </div>
  );
}
